import { useEffect } from 'react';
import useCart from '../../hooks/useCart';
import { ProductType, SkuType } from '../../types/product';

import { WEBSITE_URL } from 'core-lib/data/common';
import { trackCustomGTMEvent } from 'core-lib/utils/events';
import { EventCategoryName } from 'core-lib/types/Events';
import useProductDescription from '../../hooks/useProductDescription';
import { trackPageLoadStoreV2 } from '../../utils/events';
import ExternalVoucherPdp from './ExternalVoucherPdp';
import InternalVoucherPdp from './InternalVoucherPdp';
import Shimmer from './Shimmer';
import StorePdp from './StorePdp';

export const ProductDescriptionPage = () => {
  // custom hooks
  useCart(true);
  const { productDescriptionDataApiStatus, data, updatePdpSlice } = useProductDescription();

  useEffect(() => {
    if (data) {
      trackPageLoadStoreV2(data?.title, {
        product_id: data?.productId,
        section: data?.productType,
      });
      trackCustomGTMEvent({
        eventName: `pm_35_product_description_page_view`,
        attributes: {
          category: EventCategoryName.Store,
          page_url: `${WEBSITE_URL}/app/shop/parkplus-store/${data?.productId}`,
          sku_id: data?.productId,
        },
      });
    }
  }, [data]);

  if (
    !data
    // EXTENDED_LOADING_STATES.includes(productDescriptionDataApiStatus)
  ) {
    return <Shimmer />;
  }
  if (data && data?.productType === ProductType.Simple)
    return (
      <StorePdp
        data={data}
        apiStatus={productDescriptionDataApiStatus}
        updatePdpSlice={updatePdpSlice}
      />
    );
  switch (data?.skuType) {
    case SkuType.ExternalVoucher:
      return <ExternalVoucherPdp data={data} />;
    case SkuType.InternalVoucher:
      return <InternalVoucherPdp data={data} />;
    default:
      return (
        <StorePdp
          data={data}
          apiStatus={productDescriptionDataApiStatus}
          updatePdpSlice={updatePdpSlice}
        />
      );
  }
};
